import { render, staticRenderFns } from "./DadosDaCompra.vue?vue&type=template&id=07fc8e86&scoped=true&"
import script from "./DadosDaCompra.vue?vue&type=script&lang=js&"
export * from "./DadosDaCompra.vue?vue&type=script&lang=js&"
import style0 from "./DadosDaCompra.vue?vue&type=style&index=0&id=07fc8e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc8e86",
  null
  
)

export default component.exports